module.exports = __webpack_public_path__ + "media/images/map_icons/Playground-7ecb9519620a6ba5db8949e45fbfe9e0.svg";